<template>
  <div class="diaglog-wrapper">
    <div class="dialog-container">
      <div class="store-dialog-container">
        <form class="form">
          <p
            v-if="matchConfirmAMountPayType"
            class="point-crd-tips mb18"
            style="
              text-align: left;
              margin-left: 0px;
              margin-right: 0;
              padding: 10px;
              width: auto;
            "
          >
            Hãy đảm bảo rằng giá trị thẻ bạn lựa chọn đúng với số tiền trên thẻ
            của bạn. Nếu bạn chọn sai, bạn sẽ bị mất thẻ, chúng tôi không chịu
            trách nhiệm.
          </p>
          <input
            v-if="matchConfirmAMountPayType"
            class="mb18 point-card-editor"
            :class="[misMatch ? 'border-c' : '']"
            v-model="confirmAmount"
            type="number"
            name="confirmAmount"
            placeholder="Vui lòng nhập mệnh giá"
          />
          <p
            v-if="matchConfirmAMountPayType && misMatch"
            class="point-crd-tips mb18"
            style="
              text-align: left;
              padding: 10px;
              width: 470px;
              color: #de6262;
            "
          >
            Số tiền bạn nhập vào khác với số tiền trên thẻ đã chọn, hãy chọn lại
            mức tiền thẻ
          </p>
          <div v-if="currLocation !== 'VN'">
            <input
              class="point-card-editor mb18"
              :class="[validateErr ? 'active' : false]"
              v-model="pin"
              type="text"
              name="pin"
              placeholder="卡號"
            />
            <input
              v-if="type === NEED_PIN_SERIAL"
              class="point-card-editor mb18"
              :class="[validateErr ? 'active' : false]"
              v-model="serial"
              type="text"
              name="serial"
              placeholder="密碼"
            />
          </div>
          <div v-if="currLocation === 'VN'">
            <input
              v-if="type === NEED_PIN_SERIAL"
              class="point-card-editor mb18"
              :class="[validateErr ? 'active' : false]"
              v-model="serial"
              type="text"
              name="serial"
              placeholder="Số Seri"
            />
            <input
              class="point-card-editor mb18"
              :class="[validateErr ? 'active' : false]"
              v-model="pin"
              type="text"
              name="pin"
              placeholder="Mã Pin"
            />
          </div>
          <p v-if="!matchConfirmAMountPayType" class="point-crd-tips">
            {{ letter.pointCardTips.replace('$paymentAmount', amount) }}
          </p>
          <div
            v-if="matchConfirmAMountPayType && misMatch"
            style="width: 400px; height: 52px; margin: 0 auto"
          >
            <span class="extra-info-title" style="position: initial">
              {{ letter.payment }}:
            </span>
            <button
              class="select-amount-button j-money-dcount mb18"
              v-if="undefined != curPrice"
              style="position: relative; float: left; clear: none"
              type="button"
              @click="$emit('selectAmount', true)"
            >
              {{ curPrice.TRANS_AMOUNT }} {{ curPayType.show_currency }}
              <em class="amount-select-icon j-money-dcount"></em>
            </button>
          </div>
          <button
            @click="pay"
            :class="[submiteState == SUBMIT_ABLE ? 'active' : 'sleep']"
            class="point-card-confirm btn mb18 j-point-card-submit"
            type="button"
          >
            {{ letter.mywork_confirm }}
          </button>
        </form>
      </div>
      <button class="close-btn point-card-close" @click="close"></button>
    </div>
  </div>
</template>
<script>
const SUBMIT_ABLE = true;
export const NEED_PIN_ONLY = 1;
export const NEED_PIN_SERIAL = 2;
export default {
  data() {
    return {
      pin: '',
      serial: '',
      SUBMIT_ABLE,
      NEED_PIN_SERIAL,
      confirmAmount: null,
      validateErr: false,
      misMatch: false
    };
  },
  model: {
    prop: 'showPaymentSelecter',
    event: 'selectAmount'
  },
  props: [
    'amount',
    'type',
    'curPayType',
    'curPrice',
    'showPaymentSelecter',
    'currLocation'
  ],
  computed: {
    letter() {
      return this.$store.state.letter;
    },
    submiteState() {
      if (
        this.pin == '' ||
        (this.type == NEED_PIN_SERIAL && this.serial == '')
      ) {
        return !SUBMIT_ABLE;
      }
      return SUBMIT_ABLE;
    },
    matchConfirmAMountPayType() {
      let payType = [
        'mobifone_card',
        'vinaphone_card',
        'viettel_card',
        'gate_card',
        'zing_card'
      ];

      return payType.indexOf(this.curPayType.pay_type) > -1;
    }
  },
  methods: {
    close() {
      this.$emit('closePointCardEditor');
      this.reset();
      this.$clearDisable();
    },
    reset() {
      this.misMatch = false;
      this.confirmAmount = null;
    },
    pay() {
      if (this.submiteState == SUBMIT_ABLE) {
        if (
          this.matchConfirmAMountPayType &&
          (!this.confirmAmount ||
            this.confirmAmount.replace(/\.\d*$/, '') !=
              this.curPrice.TRANS_AMOUNT.replace(/\.0*$/, ''))
        ) {
          this.misMatch = true;
          this.validateErr = true;
          setTimeout(() => {
            this.validateErr = false;
          }, 300);

          return;
        }

        this.misMatch = false;
        this.$emit('payWidthPointCard', {
          pin: this.pin,
          serial: this.serial
        });
        this.reset();
      } else {
        this.validateErr = true;
        setTimeout(() => {
          this.validateErr = false;
        }, 300);
      }
    }
  }
};
</script>
<style lang="scss" scoped>
@import '@assets/scss/officialTopup/_dimen.scss';
.dialog-container {
  background: #fff;
  box-sizing: border-box;
  padding: 60px;
  border-radius: 20px;
}
.store-dialog-container {
  float: left;
  width: 100%;
}
.point-card-editor {
  display: block;
  box-sizing: border-box;
  margin: 0 auto;
  line-height: 80px;
  font-size: 24px;
  color: #333;
  width: 602px;
  height: 80px;
  border: 2px solid #d2d2d2;
  border-radius: 10px;
  padding: 0 24px;
  &::placeholder {
    color: #333;
  }
  &.active {
    border: 2px solid red;
  }
}
.point-crd-tips {
  margin: 0 auto;
  margin-top: 10px;
  width: 100%;
  height: auto;
  line-height: 28px;
  text-align: center;
  font-size: 20px;
}
.border-c {
  border: 1px solid #de6262;
  width: 470px;
}
.extra-info-title {
  display: inline-block;
  margin-right: 10px;
  background: transparent;
  line-height: 40px;
  font-weight: bold;
  font-size: 24px;
  color: #414141;
}
.select-amount-button {
  display: block;
  float: left;
  position: relative;
  box-sizing: border-box;
  padding: 0 15px;
  padding-right: 27px;
  border: 1px solid #c2edd6;
  height: 40px;
  background: white;
  cursor: pointer;
  line-height: 40px;
  vertical-align: top;
  text-align: left;
  font-weight: bold;
  font-size: 30px;
  color: #de6262;
  white-space: nowrap;
  -webkit-box-sizing: border-box;
}
.point-card-confirm {
  display: block;
  text-align: center;
  margin: 30px auto;
  width: 100%;
  line-height: 80px;
  height: 80px;
  font-size: 24px;
  color: #fff;
  font-weight: bold;
  background: $themeColor;
  border-radius: 10px;
  cursor: pointer;
  &.sleep {
    background: #949494;
  }
}
.point-card-close {
  cursor: pointer;
  right: 32px;
  top: 27px;
  background: url($commonImg + 'close.png') no-repeat;
  width: 28px;
  height: 28px;
}
</style>
